<template>
  <button class="Drop-Menu-Item" @click="toDelete">
    <div class="Drop-Menu-Item__svg-box">
      <DeleteBinIcon />
    </div>
    Удалить
  </button>
</template>

<script setup>
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { deleteComment } from './api/deleteComment.js';
  //-----------------------------------------
  import DeleteBinIcon from '@svg/DeleteBinIcon.vue';
  //-----------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  const emit = defineEmits(['close']);
  //-----------------------------------------
  const CONTEXT = (props.commentsPlace === 'popup') ? 'popupComments' : 'contentPageComments';
  const COMMENT = store.state.ContentSystem.Comments[CONTEXT].list.find(item => item.id == props.commentId);
  const POST = store.state.ContentSystem.Alpha.list[COMMENT.object_pk] || store.state.ContentSystem.Infonoise.list[COMMENT.object_pk];
  //-----------------------------------------
  //Удалить комментарий
  const toDelete = async () => {
    sendEmitClose();
    await deleteComment({ commentId: props.commentId});
    COMMENT.is_removed = true;
    POST.comments_count--;
  }
  //Отправляем событие закрытие дропдауна
  const sendEmitClose = () => emit('close');
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>
